import React from "react";
import ProfilePageTemplate from "../shared/ProfilePageTemplate";
import OrganizationalStructureContent from "./OrganizationalStructureContent";
import NCBTimelineSection from "./NCBTimelineSection";

const ProfilNCBContent = () => {
  const tabs = [
    {
      id: "structure",
      label: "Struktur Organisasi",
      icon: "🏗️",
      component: <OrganizationalStructureContent />,
    },
    {
      id: "timeline",
      label: "Sejarah & Timeline",
      icon: "📅",
      component: <NCBTimelineSection />,
    },
  ];

  return (
    <ProfilePageTemplate
      title="Profil NCB Interpol"
      subtitle="National Central Bureau Indonesia"
      icon="🏢"
      breadcrumbBase="NCB-Interpol"
      tabs={tabs}
      footerTitle="Set NCB Interpol Indonesia"
      footerDescription="Berkomitmen dalam menjaga keamanan dan ketertiban melalui kerja sama internasional yang efektif dalam penanggulangan kejahatan transnasional dan internasional."
      footerStats={[
        { label: "Bagian Utama", value: "3" },
        { label: "Sub Bagian", value: "12+" },
        { label: "Operasional", value: "24/7" },
      ]}
    />
  );
};

export default ProfilNCBContent;
